( function () {
    'use strict';
    espresso.newsletterpopup = {
        options: {
            autoPopup: true,
            autoPopupTimer: 10000,
            successTimer: 8000,
            cookieExpire: 365
        },
        resize: function () {
            espresso.constant.jWindow.on( 'resize', function () {
                var jHeight = ( jQuery( '.js-e-newsletter-popup-container' ).outerHeight() + 200 );
                jQuery( '.js-e-newsletter-popup-container' ).css( 'bottom', -jHeight );
            } );
        },
        buildImages: function () {
            if ( jQuery( '.js-e-newsletter-popup-container' ).length ) {
                var containerImage = jQuery( '.js-e-newsletter-popup-container' ).find( 'img' ),
                    teaserImage = jQuery( '.js-e-newsletter-popup-teaser' ).find( 'img' ),
                    imgArr = [];
                imgArr.push( containerImage, teaserImage );
                jQuery.each( imgArr, function ( index, obj ) {
                    if ( obj.length ) {
                        var jImg = new Image();
                        jImg.onload = function () {
                            jImg.width = this.width;
                            jImg.height = this.height;
                            espresso.newsletterpopup.checkForMobile();
                            espresso.newsletterpopup.checkCookie();
                        };
                        jImg.src = obj.attr( 'src' );
                        obj.after( jImg ).remove();
                    }
                    else {
                        espresso.newsletterpopup.checkForMobile();
                        espresso.newsletterpopup.checkCookie();
                    }
                } );
            }
        },
        checkForMobile: function () {
            var isMobile = jQuery( 'input[name="e-newsletter-popup-mobile"]' ).val();
            if ( isMobile !== 'True' ) {
                jQuery( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ).addClass( 'hidden-phone' );
            }
        },
        render: function () {
            var jLargePopup = jQuery( '.js-e-newsletter-popup-container' ),
                jTeaserPopup = jQuery( '.js-e-newsletter-popup-teaser' ),
                jOffset = espresso.newsletterpopup.offset(),
                popupTimer;
            jLargePopup.css( {
                'bottom': -( jLargePopup.outerHeight() + ( jOffset + 100 ) ),
                'padding-right': jLargePopup.find( 'img' ).width(),
                'width': jLargePopup.width()
            } ).show().addClass( 'closed' );
            jTeaserPopup.css( {
                bottom: -( jTeaserPopup.height() + jOffset ),
                'padding-right': jTeaserPopup.find( 'img' ).width()
            } ).show().addClass( 'closed' );
            if ( ( jQuery.cookie( 'e-newsletterState' ) !== 'hidden' && espresso.newsletterpopup.options.autoPopup === true ) ) {
                popupTimer = setTimeout( function () {
                    jLargePopup.removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', jOffset );
                }, espresso.newsletterpopup.options.autoPopupTimer );
            }
            setTimeout( function () {
                jTeaserPopup.removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', jOffset );
            }, 500 );
            this.bindings( jLargePopup, jOffset, popupTimer );
        },
        bindings: function ( jLargePopup, jOffset, popupTimer ) {
            jQuery( '.js-e-newsletter-popup-close' ).on( 'click', function ( event ) {
                event.preventDefault();
                clearTimeout( popupTimer );
                espresso.newsletterpopup.hidden( -( jLargePopup.height() + jLargePopup.find( 'img' ).height() ) );
            } );
            jQuery( 'body' ).on( 'click', function ( event ) {
                if ( jLargePopup.is( '.opened' ) === true ) {
                    if ( jQuery( event.target ).parents( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ).length === 0 && !jQuery( event.target ).is( '.js-e-newsletter-popup-container, .js-e-newsletter-popup-teaser' ) ) {
                        espresso.newsletterpopup.hidden( -( jLargePopup.height() + jLargePopup.find( 'img' ).height() ) );
                        clearTimeout( popupTimer );
                    }
                }
            } );
            jQuery( '.js-e-newsletter-popup-teaser' ).find( 'a' ).on( 'click', function ( event ) {
                event.preventDefault();
                jQuery( '.js-e-newsletter-popup-container' ).removeClass( 'closed' ).addClass( 'opened' ).css( 'bottom', jOffset );
            } );
            jQuery( '.js-e-newsletter-popup-form-submit' ).on( 'click', function () {
                espresso.newsletterpopup.formHandler.validate();
            } );
            jLargePopup.find( 'input' ).on( 'keyup', function () {
                if ( jQuery( this ).val() ) {
                    jQuery( this ).removeClass( 'error' );
                }
            } );
        },
        hidden: function ( jHeight ) {
            jQuery( '.js-e-newsletter-popup-container' ).removeClass( 'opened' ).addClass( 'closed' ).css( 'bottom', jHeight - 100 );
            this.setCookie( 'e-newsletterState', 'hidden' );
        },
        destroy: function ( jOffset ) {
            this.hidden( -jOffset * 2 );
            this.setCookie( 'e-newsletterState', 'disabled' );
            setTimeout( function () {
                jQuery( '.js-e-newsletter-popup-container' ).remove();
            }, 500 );
        },
        offset: function () {
            if ( jQuery( '.webshop-bottom-user-info' ).length && jQuery( '.webshop-bottom-user-info' ).css( 'position' ) === 'fixed' ) {
                return jQuery( '.webshop-bottom-user-info' ).height();
            }
            else if ( jQuery( '.e-nav-utilities-bottom' ).length && jQuery( '.e-nav-utilities-bottom' ).css( 'position' ) === 'fixed' ) {
                return jQuery( '.e-nav-utilities-bottom' ).height();
            }
            else {
                return 0;
            }
        },
        setCookie: function ( jCookie, jValue ) {
            jQuery.cookie( jCookie, jValue, {
                path: '/',
                expires: espresso.newsletterpopup.options.cookieExpire
            } );
        },
        checkCookie: function () {
            var eNewsletterId = jQuery( 'input[name="e-newsletter-popup-id"]' ).val().replace( /\s+/g, '' ).substr( 0, 50 );
            if ( jQuery.cookie( 'e-newsletterState' ) !== 'disabled' ) {
                this.render();
                this.setCookie( 'e-newsletterId', eNewsletterId );
            }
            else if ( jQuery.cookie( 'e-newsletterId' ) !== eNewsletterId ) {
                this.render();
                this.setCookie( 'e-newsletterState', null );
                this.setCookie( 'e-newsletterId', eNewsletterId );
            }
        },
        init: function () {
            this.buildImages();
            this.resize();
        }
    };
    espresso.newsletterpopup.formHandler = {
        validate: function () {
            var jForm = jQuery( '.js-e-newsletter-popup-container' ).find( 'form' ),
                jMethod = jQuery( 'input[name="e-newsletter-popup-method"]' ).val(),
                jThis = this;
            jQuery( jForm ).validate( {
                errorClass: 'text-error',
                errorElement: 'span',
                errorPlacement: function ( error, element ) {
                    error.appendTo( element.closest( 'div' ) );
                },
                submitHandler: function () {
                    jThis[ jMethod ]( jForm );
                }
            } );
        },
        success: function ( response ) {
            var jHeight = jQuery( '.js-e-newsletter-popup-container' ).height();
            master.tracking.newsletterSignup();
            jQuery( '.js-e-newsletter-popup-teaser' ).remove();
            jQuery( '.js-e-newsletter-popup-container' ).css( 'height', jHeight ).find( 'form' ).hide();
            jQuery( '.js-e-newsletter-popup-msg' ).fadeOut( 'fast', function () {
                jQuery( '.js-e-newsletter-comfirm-msg' ).html( response ).fadeIn( 'fast' );
            } );
            jQuery( '.js-e-newsletter-popup-loader' ).remove();
            if ( jQuery( '.js-e-newsletter-popup-container' ).is( '.opened' ) === true ) {
                setTimeout( function () {
                    espresso.newsletterpopup.destroy( jHeight );
                }, espresso.newsletterpopup.options.successTimer );
            }
        },
        mailchimp: function ( jForm ) {
            jQuery.ajax( {
                type: jForm.attr( 'method' ),
                url: jForm.attr( 'action' ).replace( '/post?', '/post-json?' ).concat( '&c=?' ),
                data: jForm.serialize(),
                timeout: 5000,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json; charset=utf-8',
                beforeSend: function () {
                    jQuery( '.js-e-newsletter-popup-loader' ).fadeIn( 'fast' );
                },
                success: function ( data ) {
                    if ( data.result !== 'success' ) {
                        jQuery( '.js-e-newsletter-popup-loader' ).fadeOut( 'fast' );
                        jQuery( '.js-e-newsletter-comfirm-msg' ).html( '<p>' + data.msg + '</p>' ).fadeIn( 'fast' );
                    }
                    else {
                        espresso.newsletterpopup.formHandler.success( '<p>' + data.msg + '</p>' );
                    }
                }
            } );
        },
        campaignmonitor: function ( jForm ) {
            jQuery.getJSON( jForm.attr( 'action' ) + '?callback=?', jForm.serialize(), function ( data ) {
                if ( data.Status === 400 ) {
                    jQuery( '.js-e-newsletter-popup-loader' ).fadeOut( 'fast' );
                    jQuery( '.js-e-newsletter-comfirm-msg' ).html( '<p>' + data.Message + '</p>' ).fadeIn( 'fast' );
                }
                else {
                    espresso.newsletterpopup.formHandler.success( '<p>' + data.Message + '</p>' );
                }
            } );
        },
        csv: function ( jForm ) {
            var response = jQuery( '.js-e-newsletter-comfirm-msg' ).html();
            jQuery.ajax( {
                type: 'POST',
                url: '/Admin/Public/FormMailer.aspx',
                data: jForm.serialize(),
                beforeSend: function () {
                    jQuery( '.js-e-newsletter-popup-loader' ).fadeIn( 'fast' );
                },
                success: function () {
                    espresso.newsletterpopup.formHandler.success( response );
                }
            } );
        },
        emailmarketing: function ( jForm ) {
            var response = jQuery( '.js-e-newsletter-comfirm-msg' ).html();
            jQuery.ajax( {
                type: 'POST',
                url: '/',
                data: jForm.serialize(),
                beforeSend: function () {
                    jQuery( '.js-e-newsletter-popup-loader' ).fadeIn( 'fast' );
                },
                success: function () {
                    espresso.newsletterpopup.formHandler.success( response );
                }
            } );
        }
    };
}() );
